// src/app/routes/adminRoutes.jsx
import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import RequireAdminAuth from "../../auth/RequireAdminAuth";

const LoginPage = lazy(() => import("../../pages/LoginPage"));
const DashboardModern = lazy(() => import("../../pages/DashboardModern"));
const AdminRegistrasiPage = lazy(() => import("../../pages/AdminRegistrasiPage"));
const AdminSkriningPage = lazy(() => import("../../pages/AdminSkriningPage"));
const AdminKlinikPage = lazy(() => import("../../pages/AdminKlinikPage"));
const AdminBillingPage = lazy(() => import("../../pages/AdminBillingPage"));
const AdminWhatsappPage = lazy(() => import("../../pages/AdminWhatsappPage"));
const AdminLaporanPage = lazy(() => import("../../pages/AdminLaporanPage"));
const AdminTundaPage = lazy(() => import("../../pages/AdminTundaPage"));
const AdminPembatalanPage = lazy(() => import("../../pages/AdminPembatalanPage"));
const AdminBukuTamuPage = lazy(() => import("../../pages/AdminBukuTamuPage"));
const AdminPengaturanPage = lazy(() => import("../../pages/AdminPengaturanPage"));
const AdminFlyers = lazy(() => import("../../pages/AdminFlyers"));
const AdminPetugas = lazy(() => import("../../pages/AdminPetugas"));
const AdminAkunPage = lazy(() => import("../../pages/AdminAkunPage"));
const AdminSkmDashboardPage = lazy(() => import("../../pages/AdminSkmDashboardPage"));
const AdminSkmHasilPage = lazy(() => import("../../pages/AdminSkmHasilPage"));
const AdminSkmMonitoringPage = lazy(() => import("../../pages/AdminSkmMonitoringPage"));
const AdminPengukuranDashboardPage = lazy(() =>
  import("../../pages/AdminPengukuranDashboardPage")
);
const AdminPengukuranPnbpPage = lazy(() => import("../../pages/AdminPengukuranPnbpPage"));
const AdminPengukuranVaksinPage = lazy(() => import("../../pages/AdminPengukuranVaksinPage"));
const AdminPerformaPemberiLayananPage = lazy(() =>
  import("../../pages/AdminPerformaPemberiLayananPage")
);
const AdminBuletinJenis = lazy(() => import("../../pages/AdminBuletinJenis"));
const AdminBuletinEdisi = lazy(() => import("../../pages/AdminBuletinEdisi"));
const AdminLogout = lazy(() => import("../../pages/AdminLogout"));

const protectedAdmin = (element) => <RequireAdminAuth>{element}</RequireAdminAuth>;

export function renderAdminRoutes() {
  return (
    <>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/dashboard" element={protectedAdmin(<DashboardModern />)} />

      <Route
        path="/admin/pengukuran"
        element={<Navigate to="/admin/pengukuran/dashboard" replace />}
      />
      <Route
        path="/admin/pengukuran/dashboard"
        element={protectedAdmin(<AdminPengukuranDashboardPage />)}
      />
      <Route
        path="/admin/pengukuran/performa-pemberi-layanan"
        element={protectedAdmin(<AdminPerformaPemberiLayananPage />)}
      />
      <Route
        path="/admin/pengukuran/target-realisasi"
        element={protectedAdmin(<AdminPengukuranPnbpPage />)}
      />
      <Route
        path="/admin/pengukuran/penggunaan-vaksinasi"
        element={protectedAdmin(<AdminPengukuranVaksinPage />)}
      />
      <Route
        path="/admin/pengukuran/kamus-indikator"
        element={<Navigate to="/admin/pengukuran/penggunaan-vaksinasi" replace />}
      />

      <Route path="/admin/registrasi" element={protectedAdmin(<AdminRegistrasiPage />)} />
      <Route path="/admin/buku-tamu" element={protectedAdmin(<AdminBukuTamuPage />)} />
      <Route path="/admin/bukutamu" element={<Navigate to="/admin/buku-tamu" replace />} />
      <Route path="/admin/skrining" element={protectedAdmin(<AdminSkriningPage />)} />
      <Route path="/admin/klinik" element={protectedAdmin(<AdminKlinikPage />)} />
      <Route path="/admin/billing" element={protectedAdmin(<AdminBillingPage />)} />
      <Route path="/admin/whatsapp" element={protectedAdmin(<AdminWhatsappPage />)} />
      <Route path="/admin/laporan" element={protectedAdmin(<AdminLaporanPage />)} />
      <Route path="/admin/tunda" element={protectedAdmin(<AdminTundaPage />)} />
      <Route
        path="/admin/pembatalan"
        element={protectedAdmin(<AdminPembatalanPage />)}
      />

      <Route path="/admin/skm" element={<Navigate to="/admin/skm/dashboard" replace />} />
      <Route
        path="/admin/skm/dashboard"
        element={protectedAdmin(<AdminSkmDashboardPage />)}
      />
      <Route path="/admin/skm/hasil" element={protectedAdmin(<AdminSkmHasilPage />)} />
      <Route
        path="/admin/skm/monitoring"
        element={protectedAdmin(<AdminSkmMonitoringPage />)}
      />

      <Route path="/admin/pengaturan" element={protectedAdmin(<AdminPengaturanPage />)} />
      <Route
        path="/admin/pengaturan/flyers"
        element={protectedAdmin(<AdminFlyers />)}
      />
      <Route
        path="/admin/pengaturan/petugas"
        element={protectedAdmin(<AdminPetugas />)}
      />
      <Route
        path="/admin/pengaturan/akun"
        element={protectedAdmin(<AdminAkunPage />)}
      />

      <Route
        path="/admin/pengaturan/vaksin"
        element={<Navigate to="/admin/pengaturan" replace />}
      />
      <Route
        path="/admin/pengaturan-vaksin"
        element={<Navigate to="/admin/pengaturan" replace />}
      />
      <Route
        path="/admin/pengaturan/flyer-digital"
        element={<Navigate to="/admin/pengaturan/flyers" replace />}
      />
      <Route
        path="/admin/akun"
        element={<Navigate to="/admin/pengaturan/akun" replace />}
      />

      <Route
        path="/admin/buletin"
        element={<Navigate to="/admin/buletin/jenis" replace />}
      />
      <Route
        path="/admin/buletin/jenis"
        element={protectedAdmin(<AdminBuletinJenis />)}
      />
      <Route
        path="/admin/buletin/edisi"
        element={protectedAdmin(<AdminBuletinEdisi />)}
      />

      <Route path="/admin/logout" element={<AdminLogout />} />
    </>
  );
}
